export const FILTER_KEYS = [
  'contract_type_ids',
  'search',
  'collection_date_start',
  'collection_date_end',
  'contract_date_start',
  'contract_date_end',
  'document_type',
  'amendment_date_start',
  'amendment_date_end',
] as const;

export const DOCUMENT_TYPES = [
  { value: 'application/msword', label: 'Microsoft Word (.doc)' },
  {
    value:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    label: 'Microsoft Word (.docx)',
  },
  { value: 'application/pdf', label: 'PDF' },
  { value: 'text/plain', label: 'Text' },
];
